export var freeze = function freeze(obj) {
  return Object.freeze(obj);
};